import * as React from "react";
const SvgFiRrELearning = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-e-learning_svg__a)">
      <path
        fill="#062147"
        d="M19.9 3.091a4 4 0 0 0-5-2.938l-1.724.493c-.437.126-.839.35-1.176.654a3 3 0 0 0-1.176-.654L9.1.153a4 4 0 0 0-4.995 2.938A5 5 0 0 0 0 8.001v7a5.006 5.006 0 0 0 5 5h6v2H8a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2h-3v-2h6a5.005 5.005 0 0 0 5-5V8a5 5 0 0 0-4.1-4.91m-6.9.44a1 1 0 0 1 .725-.96l1.725-.494A2 2 0 0 1 18 4v3.938a2.01 2.01 0 0 1-1.45 1.921L13 10.873zm-6.2-1.13a2 2 0 0 1 1.75-.324l1.725.493a1 1 0 0 1 .725.961v7.342L7.45 9.86A2.01 2.01 0 0 1 6 7.94V4a1.99 1.99 0 0 1 .8-1.6M22 15a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 2-2.817v2.754a4.014 4.014 0 0 0 2.9 3.845l3.451.987a6 6 0 0 0 3.3 0l3.451-.987A4.014 4.014 0 0 0 20 7.938V5.184A3 3 0 0 1 22 8z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-e-learning_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrELearning;
